<script>
  import { onMount } from "svelte";
  export let name;
  export let distributors;
  export let onCreateNamedPlaceholder;
  let state = {
    name: name || "",
    distributorId: null,
  };

  onMount(function () {
    document.getElementById("productName").focus();
  });

  function isSubmitDisabled() {
    return state.name.trim() === "" || state.distributorId == null;
  }
  function handleNameChange(event) {
    state.name = event.target.value.trimLeft();
  }
  function selectChange(event) {
    if (event.target.value === "Distributor") {
      state.distributorId = null;
    } else {
      state.distributorId = event.target.value;
    }
  }

</script>

<div class="list-builder__new-product">
  <div class="list-build__new-product-form media">
    <div class="list-builder__new-product-input input-wrapper media-fluid">
      <input
        type="text"
        value={state.name}
        class="input"
        id="productName"
        on:keyup={handleNameChange}
      />
    </div>
    <div
      class="list-builder__distributor-select input-wrapper select-style media-fluid align-right margin-left--small--md"
    >
      <select
        name="Distributor"
        value={state.distributorId || "Distributor"}
        on:change={selectChange}
      >
        <option value="Distributor">Distributor</option>
        {#each distributors as distributor}
          <option key={distributor.id} value={distributor.id}>{distributor.name}</option>
        {/each}
      </select>
    </div>
  </div>
  <div class="margin-top--medium margin-bottom--medium align-center">
    <button
      class="button button--primary"
      on:click|preventDefault={() => {
        if (state.distributorId) {
          onCreateNamedPlaceholder(state.name, state.distributorId);
        }
      }}
      disabled={isSubmitDisabled()}
    >
      Add Product
    </button>
  </div>
</div>
